import styled from '@emotion/styled';
import playerDefaultAvatar from './player-default-avatar.svg';

export const PlayerCardContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

type PlayerCardAvatarProps = {
  avatar?: string;
};

export const PlayerCardAvatar = styled.div<PlayerCardAvatarProps>`
  width: 40%;
  height: 90%;
  margin: 0 auto;
  background-image: url(${(props) => props.avatar || playerDefaultAvatar});
  background-color: #eaeaec;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 8px 8px 0 0;
`;
